import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "dialog-container" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Alert = _resolveComponent("Alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_router_view),
    _hoisted_1,
    _createVNode(_TransitionGroup, {
      name: "list",
      tag: "div",
      class: "alerts w-full h-full"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
          return (_openBlock(), _createBlock(_component_Alert, {
            class: "alerts",
            key: alert.ts,
            data: alert
          }, null, 8, ["data"]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}